import React, { FC, memo, useCallback, useState } from 'react'

import { FilterItemTransport, FilterTransport } from '../../../../../transports/filters-configuration-transport'
import RadioFilterItem from './radio-filter-item'

type Props = {
    filter: FilterTransport
}

const RadioFilter: FC<Props> = ({ filter }) => {
    const [selectedFilterItemPosition, setSelectedFilterItemPosition] = useState<number>(() => {
        return filter.items.findIndex(item => item.checked)
    })

    const handleFilterItemClick = useCallback((filterItemPosition: number) => {
        setSelectedFilterItemPosition(filterItemPosition)
    }, [])

    return (
        <>
            {filter.items.map((filterItem: FilterItemTransport, index) => {
                return (
                    <RadioFilterItem
                        filterItem={filterItem}
                        filterType={filter.type}
                        key={filterItem.title}
                        filterItemPosition={index}
                        isFilterItemSelected={index === selectedFilterItemPosition}
                        onFilterItemClick={handleFilterItemClick}
                    />
                )
            })}
        </>
    )
}

export default memo(RadioFilter)
